import { FormContainer, LabeledInput, Worksheet } from "uikit"
import React from "react"
import { Dropdown } from "semantic-ui-react"
import { useStore } from "store"
import { AddPersonModal } from "../../../people/AddPersonModal"
import { Footer } from "./Footer"

const SocialSecurityForm = ({
  data: {
    fields: { person_id, monthly_amount },
    isModified,
    onSubmit,
    error
  },
  submitLabel = "Done",
  isNew,
  onDelete,
  peopleOptions,
  addNewPerson
}) => {
  return (
    <Worksheet error={error}>
      <Worksheet.Body>
        <Worksheet.Row label="Person receiving the benefit" paddedField>
          <Worksheet.Field error={person_id.error}>
            <Dropdown
              {...person_id}
              placeholder="Recipient"
              options={peopleOptions}
              selection
              data-testid="recipient"
            />

            {person_id.value === "__ADD__" && (
              <AddPersonModal
                submit={personValues =>
                  addNewPerson(personValues).then(({ personId }) =>
                    person_id.onChange(null, { value: personId })
                  )
                }
                onCancel={() => person_id.onChange(null, { value: null })}
              />
            )}
          </Worksheet.Field>
        </Worksheet.Row>
        <Worksheet.Row
          label="Monthly benefit amount"
          paddedField
          description="What is the estimated monthly benefit at full retirement age?"
        >
          <Worksheet.Field error={monthly_amount.error}>
            <LabeledInput
              {...monthly_amount}
              label=""
              iconText="$"
              iconPosition="left"
              placeholder="0"
            />
          </Worksheet.Field>
        </Worksheet.Row>
      </Worksheet.Body>
      <Footer
        isNew={isNew}
        submitLabel={submitLabel}
        onSubmit={onSubmit}
        onDelete={onDelete}
        isModified={isModified}
        deleteLabel="Delete Benefit"
        error={error}
      />
    </Worksheet>
  )
}

const SocialSecurityFormContainer = FormContainer(
  {
    person_id: {
      type: "string"
    },
    monthly_amount: {
      type: "unit"
    }
  },
  (fields, ...form) => {}
)(SocialSecurityForm)

const SocialSecurity = ({ benefit, household, type, ...formProps }) => {
  const [incomes] = useStore("householdIncomes", household.id)
  const [people] = useStore("householdPeople", household.id)
  const [
    benefits,
    { addBenefit, deleteBenefit, updateBenefit, addPerson }
  ] = useStore("householdBenefits", household.id)

  const isNew = benefit === null
  const socialSecurityBeneficiaries = Object.values(benefits)
    .filter(({ type }) => type === "socialsecurity_plan")
    .map(({ person_id }) => person_id)
  const socialSecurityOwners = Object.values(incomes)
    .filter(({ type }) => type === "socialsecurity")
    .map(({ person_id }) => person_id)

  const values = isNew
    ? {
        person_id:
          Object.values(people).length === 1
            ? Object.values(people)[0].id
            : null,
        monthly_amount: null
      }
    : benefit
  const peopleOptions = Object.values(people)
    .filter(({ role }) => role === "spouse" || role === "client")
    .filter(({ id }) => !socialSecurityOwners.includes(id))
    .filter(({ id }) => !isNew || !socialSecurityBeneficiaries.includes(id))
    .map(({ id: value, first_name: text }) => ({
      value,
      text
    }))
  const canAddPerson = false

  const submit = isNew
    ? async values =>
        await addBenefit({
          household_id: household.id,
          type,
          ...values
        })
    : async values =>
        await updateBenefit({
          id: benefit.id,
          type,
          ...values
        })

  const onDelete = () =>
    deleteBenefit({
      id: benefit.id,
      household_id: household.id
    })
  if (canAddPerson) {
    peopleOptions.push({
      text: "Add person...",
      value: "__ADD__"
    })
  }
  const addNewPerson = values =>
    addPerson({ household_id: household.id, ...values })
  return (
    <SocialSecurityFormContainer
      {...{
        isNew,
        submit,
        onDelete,
        values,
        peopleOptions,
        household,
        addNewPerson,
        ...formProps
      }}
    />
  )
}
export default SocialSecurity
